<template>
  <div v-if="isSuperOrSalesUser" class="super-user-action-panel">
    <div class="panel-header" @click="toggle">
      <span class="panel-header__title">Shrpa admin only</span>
      <IconEmbedded :name="isExpanded ? 'caret-top_2-5' : 'caret-bottom_2-5'" :size="12" />
    </div>
    <div v-if="isExpanded" class="panel-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { useUserProfileStore } from "@stores/userProfileStore";

const STORAGE_PREFIX = "superUserPanelExpanded";

function getStoredExpanded(key: string): boolean {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

function setStoredExpanded(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, value.toString());
  } catch {
    /* bury storage failures */
  }
}

const route = useRoute();

const storageKey = computed(() => {
  const name = route.name;
  if (name != null) {
    return `${STORAGE_PREFIX}:${String(name)}`;
  }
  return `${STORAGE_PREFIX}:${route.path}`;
});

const isExpanded = ref(getStoredExpanded(storageKey.value));

watch(storageKey, key => {
  isExpanded.value = getStoredExpanded(key);
});

const toggle = () => {
  isExpanded.value = !isExpanded.value;
  setStoredExpanded(storageKey.value, isExpanded.value);
};

const userProfileStore = useUserProfileStore();
const isSuperOrSalesUser = computed(() => userProfileStore.isSuperOrSalesUser);
</script>

<style scoped>
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  cursor: pointer;
}

.panel-header__title {
  margin-right: 5px;
  color: grey;
  flex-grow: 1;
  text-align: right;
}

.panel-content {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
